import { render } from "./Date.vue?vue&type=template&id=38ed1b48&ts=true"
import script from "./Date.vue?vue&type=script&lang=ts"
export * from "./Date.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__